// Module
var code = `<div ng-transclude class="transclude" ng-if="\$ctrl.nextTargetDate">{{content}}</div>
<ul class="countdown list-inline" data-border="info" data-color="#ffffff" data-size="5">
  <li>
    <span class="days">{{\$ctrl.clock.days}}</span>
    <div class="cd-label">Days</div>
  </li>
  <li>
    <span class="hours">{{\$ctrl.clock.hours}}</span>
    <div class="cd-label">Hours</div>
  </li>
  <li>
    <span class="minutes">{{\$ctrl.clock.minutes}}</span>
    <div class="cd-label">Minutes</div>
  </li>
  <li>
    <span class="seconds">{{\$ctrl.clock.seconds}}</span>
    <div class="cd-label">Seconds</div>
  </li>
</ul>`;
// Exports
module.exports = code;